<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
    import router from "./router";
    export default {
        name: "App",
        data() {
            return {};
        },
        created() {
            let that = this;
            var routerString;
            if (window.currentRouter && window.currentRouter.indexOf("?") != -1) {
                routerString = window.currentRouter.split("?")[0];
            }
            
            // 2023年6月8日10:12:26 判断如果是不需要登录的页面，不用验证登录
            let hash = location.hash
            if (hash && hash.startsWith("#/scan/")) {
                return
            }
             

            this.$http.get("front/session").then(response => {
                if (response.data.status == 1) {
                    let data = response.data.data;
                    localStorage.removeItem("userinfo")
                    var userinfo = $.extend({},this.$store.state.userinfo,data);
                    if (data.typeId == "2" || data.typeId == "4" || data.typeId == "8") {
                        userinfo.auditStatus = "";
                    }
                    this.$store.commit('set', {
                        token: response.data.token
                    })
                    this.$store.commit('set', {
                        userinfo
                    })
                    localStorage.setItem('userinfo', JSON.stringify(userinfo))
                    if (response.data.status != 2) {
                        // if (data.typeId == 1) {
                        //     this.$http.get("front/studio/completeinfo").then((res) => {
                        //         if (res.data.status == 1) {
                        //             userinfo.auditStatus = res.data.data[0].auditStatus;
                        //             userinfo.completeinfo = res.data.completeinfo;
                        //             userinfo.studioName = res.data.data[0].studioName;
                        //         }
                        //         this.$store.commit('set', {
                        //             userinfo
                        //         })
                        //         localStorage.setItem('userinfo', JSON.stringify(userinfo))
                        //     })
                        // } else {
                        //     this.$store.commit('set', {
                        //         userinfo
                        //     })22222222222
                        //     localStorage.setItem('userinfo', JSON.stringify(userinfo))
                        // }
                        window.routeReady = true;
                        router.replace(window.currentRouter);
                    }
                }else if(response.data.status == 401){
                    //判断是否退出登录
                    let  redirectUrl = response.data.referer
                    if(redirectUrl){
                        window.location.href = redirectUrl
                    }
                }
            });
        },
        mounted() {
            // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
            window.addEventListener('hashchange', () => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        },
    };
</script>


// WEBPACK FOOTER //
// app.vue?122c694b